export default {
  fristTitle: '售后详情',
  secondTitle: '售后信息',
  description: '描述',
  appealInfo: '申诉信息',
  isAppeal: '是否申诉',
  appealTime: '申诉时间',
  complainant: '申诉方',
  appealDesc: '申诉说明',
  information: '支付信息',
  statistics: '用户订单状态',
  review: '审核区域',
  solution: '方案',
  deliveryCharge: '运费承担方',
  seller: '卖家',
  user: '用户',
  refundAmount: '退款金额',
  reject: '拒绝',
  currentStatus: '当前状态',
  postageBurden1: '平台',
  postageBurden2: '卖家',
  postageBurden3: '用户',
  deliveryStatus1: '新创建',
  deliveryStatus2: '待收货',
  deliveryStatus3: '待检验',
  deliveryStatus4: '取件完成',
  deliveryStatus5: '验货失败',
  afterSaleMethodMap1: '换货',
  afterSaleMethodMap2: '退货并退款',
  afterSaleMethodMap3: '维修',
  afterSaleMethodMap4: '仅退款',
  afterSaleMethodMap5: '补发或重发',
  nextOperateMap1: '否',
  nextOperateMap2: '退货单',
  nextOperateMap3: '维修',
  nextOperateMap4: '送货',
  nextOperateMap5: '退款',
  reason1: '质量问题',
  reason2: '送达时损坏',
  reason3: '货不对版',
  origin1: 'App',
  origin2: 'Wap',
  origin3: 'Email',
  origin4: 'Facebook',
  initiator1: 'Admin',
  initiator2: 'User',
  standard1: '可二次销售',
  standard2: '维修要求',
  standard3: '非人为的质量问题',
  refundMethod1: '原路退回',
  refundMethod2: 'bkash',
  refundMethod3: '银行卡',
  refundMethod4: '退为无门槛长期券',
  paymentMethodMap1: '在线支付',
  paymentMethodMap2: '货到付款',
  paymentMethodMap3: '预付款',
  disposeList1: '换货',
  disposeList2: '维修',
  disposeList3: '退货并退款',
  disposeList4: '仅退款',
  disposeList5: '补发或重发',
  sellerList1: '卖家审核通过',
  sellerList2: '卖家审核拒绝',
  salesList1: '平台审核通过',
  salesList2: '平台审核拒绝',
  newSaleColumns1: '来源',
  newSaleColumns2: 'Facebook名,手机,邮箱地址',
  newSaleColumns3: '售后原因',
  newSaleColumns4: '商品支付方式',
  newSaleColumns5: '消费税',
  newSaleColumns6: '方案',
  newSaleColumns7: '运费承担方',
  newSaleColumns8: '申请人',
  newSaleColumns9: 'System ID',
  newSaleColumns10: 'SKU ID',
  newSaleColumns11: '数量',
  UserTransactionColumns1: '订单总数',
  UserTransactionColumns2: '成功交易订单数',
  UserTransactionColumns3: '拒收订单数',
  UserTransactionColumns4: '售后单数',
  UserTransactionColumns5: '售后来源订单',
  saleReturnColumns1: '退款单ID',
  saleReturnColumns2: '用户ID',
  saleReturnColumns3: '创建时间',
  saleReturnColumns4: '售后申请ID',
  saleReturnColumns5: '原始订单号',
  saleReturnColumns6: 'SKU ID',
  saleReturnColumns7: '数量',
  saleReturnColumns8: '收件标准',
  saleReturnColumns9: '状态',
  saleReturnColumns10: '后续工单',
  saleReturnColumns11: '售后方式',
  saleReturnColumns12: 'ID',
  saleReturnColumns13: '质检员ID',
  deliveryOrderColumns1: '发货单ID',
  deliveryOrderColumns2: '用户ID',
  deliveryOrderColumns3: '创建时间',
  deliveryOrderColumns4: '售后申请ID',
  deliveryOrderColumns5: '原始订单号',
  deliveryOrderColumns6: 'SKU ID',
  deliveryOrderColumns7: '数量',
  deliveryOrderColumns8: '状态',
  deliveryOrderColumns9: '后续工单',
  deliveryOrderColumns10: '售后方式',
  deliveryOrderColumns11: '工单处理人',
  deliveryOrderColumns12: '尾程物流单号',
  inner1: '新创建',
  inner2: '待发货',
  inner3: '已发货',
  inner4: '派送中',
  inner5: '已送达',
  repairOrderColumns1: '维修单ID',
  repairOrderColumns2: '用户ID',
  repairOrderColumns3: '创建时间',
  repairOrderColumns4: '售后申请ID',
  repairOrderColumns5: '原始订单号',
  repairOrderColumns6: 'SKU ID',
  repairOrderColumns7: '数量',
  repairOrderColumns8: '商品标题',
  repairOrderColumns9: '状态',
  repairOrderColumns10: '后续工单',
  repairOrderColumns11: '售后方式',
  repairOrderColumns12: '维修人员',
  innerstandard1: '新创建',
  innerstandard2: '待处理',
  innerstandard3: '维修中',
  innerstandard4: '已修复',
  innerstandard5: '无法修复',
  refundColumns1: '退款单ID',
  refundColumns2: '用户ID',
  refundColumns3: '创建时间',
  refundColumns4: '售后申请ID',
  refundColumns5: '支付方式',
  refundColumns6: '原订单号',
  refundColumns7: 'SKU ID',
  refundColumns8: '数量',
  refundColumns9: '退款额',
  refundColumns10: '状态',
  refundColumns11: '售后方式',
  refundColumns12: '财务审核人',
  refundColumns13: '退款人',
  refundColumns14: '退款方式',
  innerstandard_pay1: '待审核',
  innerstandard_pay2: '待退款',
  innerstandard_pay3: '退款中',
  innerstandard_pay4: '退款完成',
  InformationColumns1: 'SO#',
  InformationColumns2: '订单支付额',
  InformationColumns3: '运费',
  InformationColumns4: '消费税',
  error1: '退款金额不得大于订单实付金额',
  error2: '请选择运费承担',
  success1: '请选择处理方式',
  // ---------------------------------2021/3/9新增------------
  talkInfo: 'Talk with the customer',
  passed: 'Are you sure to passed',
  rejected: 'Are you sure to reject',
  // -----------system-notify----------------------------------
  sn_pageTitle: '系统消息',
  sn_clearAll: '清除所有',
  sn_metaTitle: 'System Notify',
  sn_notificationColumns1: '通知ID',
  sn_notificationColumns2: '时间',
  sn_notificationColumns3: '类型',
  sn_notificationColumns4: '内容',
  sn_notificationColumns5: '操作',
  sn_confirm1: '订单通知',
  sn_confirm2: '售后通知',
  sn_read: '置为已读',
  sn_srueClear: '您确定要清除这些消息吗',
  express_account: 'XED物流帐号'
}
